<template lang="pug">
a.link.gap-2.align-items-center(
  v-if="props.link"
  v-bind="$attrs"
  :href="props.link"
  :rel="props.rel"
  :target="props.target"
  :class="[hoverOverrideClass, $attrs.class]"
)
  slot(v-if='$slots.prevLabel' name='prevLabel' :text="props.text")
  span(v-if="props.text") {{ props.text }}
  slot(v-if="$slots.icon" name="icon")
</template>

<script setup lang="ts">
import { type ExternalDestinationProps } from './ExternalDestination.types';
import { externalDestinationDefaults } from './ExternalDestination.defaults';
import useSkinDestinationHoverOverride from '../../../../../composables/useSkinDestinationHoverOverride';

const props = withDefaults(
  defineProps<ExternalDestinationProps>(),
  externalDestinationDefaults as any,
) as unknown as ExternalDestinationProps;

const { hoverOverrideValue, hoverOverrideClass } =
  useSkinDestinationHoverOverride(props as any);
</script>

<style lang="scss" scoped>
.link {
  &.has-hover-override:hover {
    color: v-bind('hoverOverrideValue') !important;
  }
}
</style>
